import moment from "moment";

export function getDaysInMonth(year, monthIndex) {
  const daysInMonth = moment({ year, month: monthIndex }).daysInMonth();

  return Array.from({ length: daysInMonth }, (_, i) => {
    return moment({ year, month: monthIndex, day: i + 1 }).format("DD/MM/YYYY");
  });
}

const MONTH_KEY_MAP = {
  JAN: "Jan",
  FEB: "Feb",
  MAR: "Mar",
  APR: "Apr",
  MAY: "Mei",
  JUN: "Jun",
  JUL: "Jul",
  AUG: "Aug",
  SEP: "Sep",
  OCT: "Okt",
  NOV: "Nov",
  DEC: "Des",
};

export function mapStatistikBookingToTable(apiData = []) {
  return apiData.map((item) => {
    const row = {
      cabang: item.kodeCabang,
    };

    Object.entries(item.monthlyStats || {}).forEach(
      ([monthKey, value]) => {
        const suffix = MONTH_KEY_MAP[monthKey];
        if (!suffix) return;

        row[`totalUE${suffix}`] = value.totalUE ?? 0;
        row[`totalBooking${suffix}`] = value.totalBooking ?? 0;
        row[`percentTotal${suffix}`] = value.bookingPercentage ?? "0%";
        row[`realisasiBooking${suffix}`] =
          value.realisasiBooking ?? 0;
        row[`percentRealisasi${suffix}`] =
          value.realisasiPercentage ?? "0%";
      },
    );

    return row;
  });
}

export const tableColumns = [
  {
    key: "cabang",
    label: "Cabang",
    headerStyle: { display: "none" },
  },
  {
    key: "totalUEJan",
    label: "Total UE",
  },
  {
    key: "totalBookingJan",
    label: "Total Booking",
  },
  {
    key: "percentTotalJan",
    label: "%",
  },
  {
    key: "realisasiBookingJan",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiJan",
    label: "%",
  },
  {
    key: "totalUEFeb",
    label: "Total UE",
  },
  {
    key: "totalBookingFeb",
    label: "Total Booking",
  },
  {
    key: "percentTotalFeb",
    label: "%",
  },
  {
    key: "realisasiBookingFeb",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiFeb",
    label: "%",
  },
  {
    key: "totalUEMar",
    label: "Total UE",
  },
  {
    key: "totalBookingMar",
    label: "Total Booking",
  },
  {
    key: "percentTotalMar",
    label: "%",
  },
  {
    key: "realisasiBookingMar",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiMar",
    label: "%",
  },
  {
    key: "totalUEApr",
    label: "Total UE",
  },
  {
    key: "totalBookingApr",
    label: "Total Booking",
  },
  {
    key: "percentTotalApr",
    label: "%",
  },
  {
    key: "realisasiBookingApr",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiApr",
    label: "%",
  },
  {
    key: "totalUEMei",
    label: "Total UE",
  },
  {
    key: "totalBookingMei",
    label: "Total Booking",
  },
  {
    key: "percentTotalMei",
    label: "%",
  },
  {
    key: "realisasiBookingMei",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiMei",
    label: "%",
  },
  {
    key: "totalUEAJunr",
    label: "Total UE",
  },
  {
    key: "totalBookingJun",
    label: "Total Booking",
  },
  {
    key: "percentTotalJun",
    label: "%",
  },
  {
    key: "realisasiBookingJun",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiJun",
    label: "%",
  },
  {
    key: "totalUEJul",
    label: "Total UE",
  },
  {
    key: "totalBookingJul",
    label: "Total Booking",
  },
  {
    key: "percentTotalJul",
    label: "%",
  },
  {
    key: "realisasiBookingJul",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiJul",
    label: "%",
  },
  {
    key: "totalUEAug",
    label: "Total UE",
  },
  {
    key: "totalBookingAug",
    label: "Total Booking",
  },
  {
    key: "percentTotalAug",
    label: "%",
  },
  {
    key: "realisasiBookingAug",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiAug",
    label: "%",
  },
  {
    key: "totalUESep",
    label: "Total UE",
  },
  {
    key: "totalBookingSep",
    label: "Total Booking",
  },
  {
    key: "percentTotalSep",
    label: "%",
  },
  {
    key: "realisasiBookingSep",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiSep",
    label: "%",
  },
  {
    key: "totalUEOkt",
    label: "Total UE",
  },
  {
    key: "totalBookingOkt",
    label: "Total Booking",
  },
  {
    key: "percentTotalOkt",
    label: "%",
  },
  {
    key: "realisasiBookingOkt",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiOkt",
    label: "%",
  },
  {
    key: "totalUENov",
    label: "Total UE",
  },
  {
    key: "totalBookingNov",
    label: "Total Booking",
  },
  {
    key: "percentTotalNov",
    label: "%",
  },
  {
    key: "realisasiBookingNov",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiNov",
    label: "%",
  },
  {
    key: "totalUEDes",
    label: "Total UE",
  },
  {
    key: "totalBookingDes",
    label: "Total Booking",
  },
  {
    key: "percentTotalDes",
    label: "%",
  },
  {
    key: "realisasiBookingDes",
    label: "Realisasi Booking",
  },
  {
    key: "percentRealisasiDes",
    label: "%",
  },
];

export const groupHeaders = [
  {
    label: "cabang",
    colSpan: 1,
    rowSpan: 2,
    style: {
      verticalAlign: "middle",
    },
  },
  {
    label: "JAN",
    colSpan: 5,
  },
  {
    label: "FEB",
    colSpan: 5,
  },
  {
    label: "MAR",
    colSpan: 5,
  },
  {
    label: "APR",
    colSpan: 5,
  },
  {
    label: "MEI",
    colSpan: 5,
  },
  {
    label: "JUN",
    colSpan: 5,
  },
  {
    label: "JUL",
    colSpan: 5,
  },
  {
    label: "AGU",
    colSpan: 5,
  },
  {
    label: "SEP",
    colSpan: 5,
  },
  {
    label: "OKT",
    colSpan: 5,
  },
  {
    label: "NOV",
    colSpan: 5,
  },
  {
    label: "DES",
    colSpan: 5,
  },
];

// utils/buildExcelRequestBodyStatistikBooking.js

const MONTHS = [
  { label: "JAN", key: "Jan" },
  { label: "FEB", key: "Feb" },
  { label: "MAR", key: "Mar" },
  { label: "APR", key: "Apr" },
  { label: "MEI", key: "Mei" },
  { label: "JUN", key: "Jun" },
  { label: "JUL", key: "Jul" },
  { label: "AUG", key: "Aug" },
  { label: "SEP", key: "Sep" },
  { label: "OKT", key: "Okt" },
  { label: "NOV", key: "Nov" },
  { label: "DES", key: "Des" },
];

export const buildExcelRequestBodyStatistikBooking = ({
  year,
  dataTable = [],
}) => {
  const yearValue = year?.value || year;

  return {
    filename: `${yearValue}_Laporan_Statistik_Booking`,
    sheets: [
      {
        name: `Statistik Booking ${yearValue}`,
        headers: [
          {
            key: "cabang",
            title: "Cabang",
          },
          ...MONTHS.map((month) => ({
            title: month.label,
            children: [
              {
                key: `totalUE${month.key}`,
                title: "Total UE",
              },
              {
                key: `totalBooking${month.key}`,
                title: "Total Booking",
              },
              {
                key: `percentTotal${month.key}`,
                title: "%",
              },
              {
                key: `realisasiBooking${month.key}`,
                title: "Realisasi Booking",
              },
              {
                key: `percentRealisasi${month.key}`,
                title: "%",
              },
            ],
          })),
        ],
        data: dataTable,
      },
    ],
  };
};
